// extracted by mini-css-extract-plugin
module.exports = {"questionHeader":"styles_questionHeader__3179o"};